import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import ContextualString from '../../../../../../../../components/contextual/ContextualString';
import flyerPrintTemplateStrings from './contextualStrings';
import { getAsset } from '../../../../../../../../util/assets';
import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import { getUtmParamsForQrCodeUrl } from '../helpers';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    organization_name: PropTypes.string.isRequired,
  }).isRequired,
};

const FlyerPrintTemplateSBNoJoinCode = ({ albumFolder, account }) => {
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);
  const url = `https://waldophotos.com/@${account.username}`;

  return (
    <Fragment>
      <p
        style={{
          top: '30.6%',
        }}
        className="marketing-material-flyer-main-copy"
      >
        <strong>{account.organization_name}</strong>{' '}
        <ContextualString
          id="shutterbugMainCopy"
          defaultMessage="is excited to announce that you’ll be able to view, download, and share all your favorite photos through our Waldo Photos gallery!"
          type={albumFolder.album_type}
          subtype={albumFolder.album_subtype}
          strings={flyerPrintTemplateStrings}
          values={{
            orgName: account.organization_name,
          }}
        />
      </p>

      <p
        style={{
          top: '48.2%',
        }}
        className="marketing-material-flyer-target-enroll-copy"
      >
        Visit <strong>{url}</strong>
      </p>

      <div
        style={{
          top: '56.2%',
          right: '14%',
        }}
        className="marketing-material-flyer-qrcode-secondary sb-no-jc-flyer-qrcode"
      >
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({ url, albumFolder })}
          size={width * 0.11 ?? 500}
        />
      </div>

      <img
        ref={templateRef}
        src={getAsset(
          '/marketing-material/MARKETING_FLYER_SB_NO_JOIN_CODE.png',
        )}
        alt=""
      />
    </Fragment>
  );
};

FlyerPrintTemplateSBNoJoinCode.propTypes = propTypes;

export default FlyerPrintTemplateSBNoJoinCode;
